import { nextProjectUrl } from '@shared/constants/urls';
import { formatAmountDisplay } from '@shared/helpers/number';

import type { ApplicationFarmPoolSchemaPayload } from '@api/types/applications';

import { FarmCard } from '@ui/uikit/components/common/cards/FarmCard';

import { useFarmPoolsAPR } from '../entities/farmPools/api/web3/farmPoolsAPR/useFarmPoolsAPR';
import {
  ApplicationFarmPoolSharingController,
  FarmPoolSharingControl,
} from './FarmPoolSharingControl';

type Props = {
  pool: ApplicationFarmPoolSchemaPayload;
};

export const FarmCardWithAPR = ({ pool }: Props) => {
  const farmPoolHandle =
    pool.address && pool.chain
      ? { address: pool.address as `0x${string}`, chainId: pool.chain }
      : undefined;

  const aprResults = useFarmPoolsAPR(farmPoolHandle ? [farmPoolHandle] : []);
  const rawApr = Number(aprResults.at(0)?.apr);
  const apr = `${rawApr ? formatAmountDisplay(rawApr) : 0}%`;

  return (
    <FarmCard
      pool={{ ...pool, staked: formatAmountDisplay(pool.staked || 0) }}
      apr={apr}
      link={nextProjectUrl.staking(`/farms/${pool.id}`)}
      sharingControl={
        <ApplicationFarmPoolSharingController pool={pool}>
          <FarmPoolSharingControl />
        </ApplicationFarmPoolSharingController>
      }
    />
  );
};
